<template>
  <div>
    <!-- <a-row>
      <a-col :span="24">
        <a-col :span="24" id="button-container">
          <a-popover v-model="visible" trigger="hover" placement="rightTop">
            <div slot="title">Help</div>
            <div slot="content" style="width: 600px">
              <ul>
                <li>
                  PerturbDB provides detailed gene set enrichment analysis
                  results, including HALLMARK, WIKIPATHWAY and KEGG pathways. We
                  offer buttons to toggle and view enrichment results in
                  different cell groups;
                </li>
                <li>
                  Click the button to view enrichment results of different
                  groups.
                </li>
              </ul>
            </div>
            <a-button type="danger" size="small">
              <a-icon type="question-circle" /><a-icon
                v-if="!this.visible"
                type="caret-down" />
              <a-icon v-if="this.visible" type="caret-up"
            /></a-button>
          </a-popover> </a-col
      ></a-col>
    </a-row> -->
    <a-tabs type="card" @change="callback" style="margin-top: 10px">
      <a-tab-pane key="1" tab="Hallmark">
        <hallmark />
      </a-tab-pane>
      <a-tab-pane key="2" tab="KEGG"> <kegg /> </a-tab-pane>
      <a-tab-pane key="3" tab="WikiPathways"> <wiki /> </a-tab-pane>
      <!-- <a-tab-pane key="4" tab="REACTOME">
        <reactome />
      </a-tab-pane> -->
    </a-tabs>
  </div>
</template>
<script>
import hallmark from "./gseaSub/hallmark.vue";
import wiki from "./gseaSub/wiki.vue";
import kegg from "./gseaSub/kegg.vue";
// import reactome from "./gseaSub/reactome.vue";
export default {
  components: {
    hallmark,
    wiki,
    kegg,
    // reactome,
  },
  methods: {
    hide() {
      console.log(111);
      this.visible = false;
    },
  },
  data() {
    return {
      // 帮助文档
      visible: false,
    };
  },
};
</script>
<style></style>
